import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createFormat } from "../../helpers/http_formats_requests";

export default function FormatNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Formato de Produto",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createFormat(data, () => navigate('/formatos'))
    };

    return <DynamicFormPage title={"Formatos - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
